import React, {PropTypes} from 'react';
import './package_details.less'
import {Link, browserHistory} from 'react-router';
import LoggedinFooter from '../../footer/loggedin_footer';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import postAShipmentActions from '../post_a_shipment_actions';
import $ from 'jquery';
import fileUploadActions from '../../image_upload/file_upload_actions';
import CONSTANTS from '../../common_constants';
import InputComponent from '../../components/input_component/input_component';
import Select from 'react-select';
import ReactDOM from 'react-dom';
import PriceAdjustment from '../../components/price_adjustment/price_adjustment';
import validate from '../../util/validate';
import {toTitleCase,join,localTimestampToGMT,GMTTimeStampToLocal} from '../../util/common';
import ShowError from '../../components/error/show_error';
import authActions from '../../auth/auth_actions';
import packageSizeDetails from '../post_a_shipment_data'


class UploadImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUrls : props.allImages || []
    }
  }
  uploadImage = () =>{
    $('input[type=file]').trigger('click');
  }
  componentWillReceiveProps(newProps){
    this.setState({
        imageUrls : newProps.allImages
    })
  }
  getFileObject = () =>{
    let imageUrl = null;
    const self  = this;
    // here the function should return the image object
    let file = this.refs.imageUpload.files[0];
    this.setState({
      isLoading: true
    })
    fileUploadActions.shipmentImageUpload(file).then((successData)=> {
      if(successData){
        imageUrl = successData.successMessage;
      }
      this.setState({
        isLoading: false
      })
      self.props.getImgUrl(imageUrl)
    }, (error)=>{
      this.setState({
        isLoading: false
      })
      console.log("error" + error);
    })
  }
  render() {
    const {imageUrls} = this.state;
    return (
      <div className = "upload-image-wrap">
        {this.state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        {
          imageUrls.length > 0 && imageUrls.map(function(imgURL, index) {
            return(
                <div key = {index}className = "images-uploaded-section">
                  <div className = "uploaded-img"style={{"backgroundImage": 'url("' + imgURL + '")'}} ></div>
                </div>
                );
              })
        }
        {
          imageUrls.length < 4 && <div className ="image-upload-section">
          <span className="icon-group img-upload" onClick={this.uploadImage}><span className="path1"></span><span className="path2"></span></span>
          <input className="displayNone" type="file" accept="image/*" ref="imageUpload" onChange={this.getFileObject} />
          </div>
        }
    </div>
    )
  }
}
class CustomRadioButton extends React.Component{
  constructor(props){
    super(props);
    this.createCheckBox = this.createCheckBox.bind(this);
    this.selectedCheckBox = this.selectedCheckBox.bind(this);
    this.state = {
      selected: ''
    }
  }

  selectedCheckBox(selectedRadioButton){
    this.setState({
      selected: selectedRadioButton
    })
    this.props.getValueCallback(selectedRadioButton);
  }

  createCheckBox(dataArr, radioButtonName){
    const {props} = this;
    let self = this;
    let checkBoxArr = [];
    let selected;
    (props.selected == null || props.selected == undefined) ?  (selected = null) : (selected = props.selected);

    if((dataArr != null || dataArr != undefined || dataArr != '') && dataArr && dataArr.length > 0){

      (selected >= dataArr.length) ? (selected = 0) : (selected = selected);

      dataArr.forEach( (CheckBoxLabel, index) => {
        let CheckBoxLabelText = CheckBoxLabel.label
        let CheckBoxLabelDescription = CheckBoxLabel.description
        if(selected == index){
          checkBoxArr.push( <div className="radio-button" key={index}><input checked="true" className="checkbox" type="radio" name={radioButtonName} onClick={this.selectedCheckBox.bind(self, CheckBoxLabelText)} value={radioButtonName} id={radioButtonName + index} /><label className="radio-button-label" htmlFor={radioButtonName + index}></label> <label htmlFor={radioButtonName + index} className="radio-button-background" ></label><div className = "content-wrap"><label htmlFor={radioButtonName + index} className="radio-button-name" >{CheckBoxLabelText}</label></div><div className = "description">{CheckBoxLabelDescription}</div></div> );
        }else{
          checkBoxArr.push( <div className="radio-button" key={index}><input className="checkbox" type="radio" name={radioButtonName} onClick={this.selectedCheckBox.bind(self, CheckBoxLabelText)} value={radioButtonName} id={radioButtonName + index} /><label className="radio-button-label" htmlFor={radioButtonName + index}></label> <label htmlFor={radioButtonName + index} className="radio-button-background" ></label><div className = "content-wrap"><label htmlFor={radioButtonName + index} className="radio-button-name" >{CheckBoxLabelText}</label></div><div className = "description">{CheckBoxLabelDescription}</div></div> );
        }

      })
      return checkBoxArr;
      // return dataArr.map((CheckBoxName, index) = > { <div className="radio-button"> <input type="radio" name={CheckBoxName} key={} value={CheckBoxName} /> {CheckBoxName}</div> });
    }
  }

  render(){
    const {props, state} = this;
    let radioButtonNameArray = props.radioButtonNameArray;
    let radioButtonName = props.radioButtonName;
    let checkBoxString = this.createCheckBox(radioButtonNameArray, radioButtonName);
    return (
      <div className="custom-radio-button-wrap">
        {checkBoxString}
      </div>
    )
  }
}


class PackageDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      postAShipment : props.postAShipment,
      categories:[]
    }
  }
  goBack = () =>{
    if(this.state.shipmentId)
      browserHistory.push('/post-a-shipment/upload-photo?shipmentId='+ this.state.shipmentId);
    else
      browserHistory.push('/post-a-shipment/upload-photo');
  }
  componentDidMount(){
    if(validate.isEmpty(this.props.postAShipment))
        browserHistory.push('/post-a-shipment');
    const shipmentId = this.props.location.query.shipmentId;
    this.setState({
      shipmentId
    })
    this.updateSelectBoxImg();    //get custom icon for select drop down
    this.getAllShipmentCategories()   //get all shipment categories on page load
    if(!this.props.postAShipment.itemSize)
    {
      let postAShipment = Object.assign({},this.state.postAShipment);
      postAShipment.itemSize = 1;
      this.setState({
        postAShipment
      })
    }
  }
  radioButtonChangeHandler = (value) =>{
    this.setState({error:null});
    let selectedValue ;
    if(value == "Small")
      selectedValue = 1;
    else if(value == "Medium")
      selectedValue = 2;
    else if(value == "Large")
      selectedValue = 3;
    else if(value == "Extra Large")
      selectedValue = 4
    let postAShipment = Object.assign({},this.state.postAShipment);
    postAShipment.itemSize = selectedValue;
    this.setState({
      postAShipment
    })
  }
  getAllShipmentCategories = () =>{
    const self = this;
    this.setState({
      ajaxInProgress:true
    })
    let postAShipment;
    this.props.postAShipmentActions.getShipmentCategories().then((data)=>{
        postAShipment = Object.assign({},this.state.postAShipment);
        let categories = [];
        let initial = {
          value : '',
          label : 'Select a category'
        }
        if(!this.props.postAShipment.itemCategory)
        {
          postAShipment.itemCategory = ""
        }
        categories.push(initial)
        data.categories.forEach((category)=>{
          let temp = {
            value : category.id,
            label : category.name
          }
          categories.push(temp)
        })
        this.setState({
          categories,
          postAShipment,
          ajaxInProgress:false
        })
    }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          this.setState({
              ajaxInProgress: false});
              this.props.authActions.sessionValid(false);
              cookies.delete('_sd');
              return ;
          }
        this.setState({ajaxInProgress: false});
        this.setState({error: errorRes.error, validationError: validationError});
    })
  }
  updateSelectBoxImg = ()=>{
    const firstChild = 0;
    const spanElement = ReactDOM.findDOMNode(this.refs.stateSelect).getElementsByClassName("Select-arrow-zone")[firstChild].childNodes[firstChild];
    spanElement.className = '';
    spanElement.className = 'icon-down-arrow-outline';
  }
  getImageUrl = (URL) =>{
     let postAShipment = Object.assign({},this.state.postAShipment);
     postAShipment.imageIds.push(URL)
     this.setState({
       postAShipment
     })
  }
  updateSelectValue = (e) =>{
    let postAShipment = Object.assign({},this.state.postAShipment)
    postAShipment.itemCategory = e.value;
    this.setState({
      postAShipment
    });
  }
  changeHandler = (type , value) =>{

    const {userData} = this.props.authState;


    let postAShipment = Object.assign({},this.state.postAShipment)
    postAShipment[type] = value;
    if(type == 'itemValue')
    {
      postAShipment['shipmentCost'] = Math.round(((value * 0.1) > 20 ? (value * 0.1) : 20).toFixed(1));
      postAShipment[type] = Math.round(value);
    }
    this.setState({
        postAShipment
    })
    
    if(userData.email) amplitude.getInstance().setUserId(userData.email);
    amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.POST_ITEM_PACKAGE_DETAILS_ADDED);
  }
  submit = (e) =>{
    e.preventDefault();
    this.setState({error:null});
    const self = this;
    let postAShipment = Object.assign({},this.state.postAShipment)
    const validationError = {
        title: !validate.name(postAShipment.title),
        itemValue: !validate.numeric(postAShipment.itemValue),
        itemCategory : (postAShipment.itemCategory == "") ? (true) : false
    };
    const validationMap = {
        title: 'Title',
        itemCategory: 'Item Category',
        itemValue : 'Iteam Value'
    };
    let errorMsg = "";
    const validationFields = [];
    Object.keys(validationError).forEach((key) => {
        if (validationError[key])
            validationFields.push(validationMap[key]);
        }
    );
    if (validationFields.length) {
        errorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
            if (validationFields.length === 1)
                return "";
            if (idx > 0 && idx < validationFields.length - 1)
                return ", ";
            else if (idx === validationFields.length - 1)
                return " and ";
            return "";
        }) + '.';
    }
    if(errorMsg){
       $("html, body").animate({scrollTop: 0}, 1000);
      this.setState({
        error : errorMsg,
        validationError : validationError
      });
      return;
    }
    this.props.postAShipmentActions.storeAShipmentDetail(postAShipment);
    if(this.state.shipmentId)
      browserHistory.push('/post-a-shipment/pickup-details?shipmentId='+ this.state.shipmentId);
    else
      browserHistory.push('/post-a-shipment/pickup-details');
  }
  saveAsDraft = (e) =>{
    e.preventDefault();
    this.setState({error:null});
    const validationError = {
        title: !validate.name(this.state.postAShipment.title)
    };
    const validationMap = {
        title: 'Title'
    };
    let errorMsg = "";
    const validationFields = [];
    Object.keys(validationError).forEach((key) => {
        if (validationError[key])
            validationFields.push(validationMap[key]);
        }
    );
    if (validationFields.length) {
        errorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
            if (validationFields.length === 1)
                return "";
            if (idx > 0 && idx < validationFields.length - 1)
                return ", ";
            else if (idx === validationFields.length - 1)
                return " and ";
            return "";
        }) + '.';
    }
    if(errorMsg){
      this.setState({
        error : errorMsg,
        validationError : validationError
      });
      return;
    }
    let parameters = Object.assign({} , this.state.postAShipment);
    if(parameters.itemCategory == "")
    {
      delete parameters['itemCategory'];
    }
    parameters.shipmentStatus = 1;
    parameters.shipmentType = 1 ; //post a shipment
    if("isIWillMeetCarrierAtDelivery" in parameters)
      delete parameters['isIWillMeetCarrierAtDelivery']
    if("isIWillMeetCarrierAtPickup" in parameters)
      delete parameters['isIWillMeetCarrierAtPickup']
    if("deliveryDate" in parameters)
      delete parameters['deliveryDate']
    this.setState({
      ajaxInProgress : true
    })
    let API = "CREATE";
    if(this.state.shipmentId)
      API = "UPDATE"
    this.props.postAShipmentActions.createAshipment(parameters,API).then(() => {
        this.setState({ajaxInProgress: false});
        browserHistory.push('/dashboard');
    }, (errorRes) => {
        if(errorRes.error === CONSTANTS.sessionInvalid){
          this.setState({ajaxInProgress: false})
          this.props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        this.setState({ajaxInProgress: false,successMsg:""});
    })
  }
  render() {
    const postAShipment = this.state.postAShipment;
    const loader = <div className="loader-button"></div>;
    let imgIds = postAShipment.imageIds || [];
    let categories = this.state.categories;
    let categorySelectedValue = postAShipment.itemCategory;
    let itemSize = packageSizeDetails.data;
    let selectedIndex= postAShipment.itemSize ? postAShipment.itemSize-1 : 0;
    let basePriceDecimal = ((postAShipment.itemValue * 0.1) > 20 ? (postAShipment.itemValue * 0.1) : 20 ).toFixed(1)
    let basePrice = Math.round(basePriceDecimal)
    let increasePriceDecimal = 0 ,increasePrice = 0;
    if(postAShipment.shipmentCost)
       increasePriceDecimal =  (postAShipment.shipmentCost - basePrice) < 0 ? 0 :(postAShipment.shipmentCost - basePrice).toFixed(1) ;
    increasePrice = Math.round(increasePriceDecimal)
    return (
      <div id="postShipmentPackageDetailsWrap">
        <div className = "wrapper post-a-shipment-package-details-wrap" >
          <div className="back-section" onClick = {this.goBack}>
              <span className="icon-icn_back"></span>
              <span className = "back-content">Back</span>
          </div>
          {this.state.ajaxInProgress && <div className = "loader-wrapper"><div className = "loader"></div></div>}
          <div className = "post-a-shipment-package-details">
            <div className ="error-section">
              {this.state.error && <ShowError errorMessage = {this.state.error} />}
            </div>
            <div className = "heading">
                Enter Package Details
            </div>
            <UploadImage allImages = {imgIds} getImgUrl = {this.getImageUrl}/>
            <div className = "package-details">
              <div className = "sub-heading">
                Details
              </div>
              <div className ="input-details-wrap">
                <div className = "input-details">
                  <InputComponent type="text" dollar ={false} value = {postAShipment.title} title = "Title" placeholder = "Item name" for ="title" changeHandler = {this.changeHandler}/>
                </div>
                <div className = "input-details">
                  <InputComponent type="number" dollar ={true} value = {postAShipment.itemValue} title = "Item value" placeholder = " Enter market value of your package" for ="itemValue" changeHandler = {this.changeHandler}/>
                </div>
              </div>
              <div className ="instruction">
                This value is used for insurance purposes, so try to be as accurate as possible.
              </div>
              <div className="item-category-section">
                <div className = "sub-heading">
                  Item category
                </div>
                <div className = "select-section">
                  <Select ref="stateSelect"searchable={false} options={categories} onChange={this.updateSelectValue} className="select" value={categorySelectedValue} clearable={false}></Select>
                </div>
              </div>
              <div className="package-size-section">
                <div className = "sub-heading">
                  Package Size
                </div>
                <CustomRadioButton selected ={selectedIndex}defaultSelect = {true} radioButtonNameArray = {itemSize} radioButtonName = "itemSize" getValueCallback = {this.radioButtonChangeHandler}/>
              </div>
              <div className ="shipment-cost-section">
                <div className = "sub-heading">
                  Shipment cost
                </div>
                <div className="price-section-wrap">
                  <div className = "price-section">
                    <div className = "title">
                      Recommended base price
                    </div>
                    <div className = "amount disabled">
                      ${basePrice}
                    </div>
                  </div>
                  <div className = "price-section amt">
                    <div className = "title">
                      Your price increase
                    </div>
                    <div className = "amount green">
                      + ${increasePrice || 0  }
                    </div>
                  </div>
                </div>
                {
                  postAShipment.itemValue != null && <div className = "price-adjustment-section">
                    <PriceAdjustment changeHandler = {this.changeHandler} minPrice ={basePrice}  price = {postAShipment.shipmentCost} for = "shipmentCost"/>
                  </div>
                }
              </div>
              <div className ="instruction">
                Shipment cost is based off of the market value, package size, and distance.
              </div>
            </div>
            <div className = "submit-section">
              <div className = "submit-options">
                  <button className = "btn orange" onClick = {this.submit} >Next</button>
              </div>
              <div className = "submit-options m-l">
                  <button className = "btn green" onClick = {this.saveAsDraft} >{this.state.ajaxInProgress? loader : 'Save and Exit'}</button>
              </div>
            </div>
          </div>
        </div>
        <LoggedinFooter />
      </div>
    )
  }
}

PackageDetails = connect((state) => {
  return {
    postAShipment : state.app.postAShipment,
    authState : state.app.auth
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    postAShipmentActions :bindActionCreators(postAShipmentActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch)
  }
})(PackageDetails);

export default PackageDetails;



// WEBPACK FOOTER //
// app/post_a_shipment/package_details/package_details.jsx